<div class="flex center">
    <div #loadingOverlayPage class="overlayPage flex center" [class.hidden]="isHidden$.value">
        <app-spinner></app-spinner>
    </div>
</div>
